/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import Warning from '@assets/icons/warning.svg'
import { useBrand } from '@contexts/index'
import { Button, CTA } from '@components/ui'
import { tracking, updateDatalayer } from '@utils/helpers/tracking'
import { customEvent } from '@utils/helpers/tracking'

const Map = ({ search, label, toggleListView }) => {
  const brand = useBrand()
  const [dealers, setDealers] = useState([])
  const [selectedDealer, selectDealer] = useState(null)
  //const [maps, setMaps] = useState(null);
  const [isMapView, setMapView] = useState(!toggleListView)
  const mapsElement = useRef()
  const searchInput = useRef('')
  const [pinnedDealer, pinDealer] = useState(null)
  const [isSearching, setIsSearching] = useState(false)
  const [isDealerFound, setDealerFound] = useState(true)

  useEffect(() => {
    //if (maps) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

    window.customMap = new mapsWrapper.DynamicMap(mapsElement.current, {
      accessToken:
        brand === 'lexus'
          ? process.env.NEXT_PUBLIC_LEXUS_MAPBOX_TOKEN
          : process.env.NEXT_PUBLIC_TOYOTA_MAPBOX_TOKEN,
      countryCode: ['GB'],
      language: 'en',
      addCountryBoundaries: true,
      highResBoundary: true,
      boundsPreservePaddingLeft:
        document.documentElement.clientWidth < 900 ? 50 : 400,
      boundsPreservePaddingTop:
        document.documentElement.clientWidth < 900 ? 250 : 50,
      boundsPreservePaddingBottom: 50,
      boundsPreservePaddingRight: 50,
      maxZoom: 15,
      minZoom: 10,
      fitToBounds: 'recalc',
      // disableScrollZoom: true
    })

    // add boundaries
    // window.customMap.addCountryBoundaries(["GB"], { highResBoundary: true })

    // add auto complete
    new mapsWrapper.AutoComplete({
      autoCompleteInput: document.getElementById('places'),
      accessToken:
        brand === 'lexus'
          ? process.env.NEXT_PUBLIC_LEXUS_MAPBOX_TOKEN
          : process.env.NEXT_PUBLIC_TOYOTA_MAPBOX_TOKEN,
      countryCode: ['GB', 'IM', 'JE', 'GG'],
      types: 'place,locality,neighborhood,region,postcode',
      onLocationSelect: (location) => {
        if (location) {
          const lon = location.coordinates[0]
          const lat = location.coordinates[1]
          getDealersList({ lat, lon }, (result) => {
            // const radiusResult = result.dealers.filter(dealer =>  dealer.distance < 50)
            setIsSearching(false)
            setDealers(result.dealers)
            addMarkers(result.dealers)
            setDealerFound(result.dealers.length > 0)
          })
        }
      },
    })
    //}
  }, [])

  useEffect(() => {
    search(selectedDealer)
    updateDatalayer('dealer', selectedDealer)
  }, [selectedDealer])

  const addMarkers = (dealers) => {
    window.customMap.clearMarkers()
    dealers.map((d, index) => {
      window.customMap.addMarker(d.address.geo, {
        fitToBounds: true,
        boundsPreservePaddingLeft:
          document.documentElement.clientWidth < 900 ? 50 : 400,
        boundsPreservePaddingTop:
          document.documentElement.clientWidth < 900 ? 250 : 50,
        boundsPreservePaddingBottom: 50,
        boundsPreservePaddingRight: 50,
        markerImage: 'toyota-black-innericon-text-dark',
        markerClick: () => {
          window.customMap.focusOn({ coordinates: d.address.geo })
          pinDealer(index + 1)

          customEvent({
            name: 'componentevent',
            componentName: tracking.componentName(),
            componentGroup: tracking.componentGroup(),
            action: 'map-click-icon',
            label: `${d.name}`,
          })

          // expand dealer on click on
          const expandedDealer = dealers.map((dealer, i) => ({
            ...dealer,
            isDetailsExpanded: i === index ? true : dealer.isDetailsExpanded,
            isOpeningExpanded: i === index ? true : dealer.isOpeningExpanded,
          }))
          setDealers(expandedDealer)

          setTimeout(() => {
            document
              .querySelector(`.dealer-${index}`)
              .scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 50)
        },
      })
    })
  }

  const getDeviceGeoLocation = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      const lon = position.coords.longitude
      const lat = position.coords.latitude

      // reverse search
      window.customMap.geocoder.reverse([lon, lat]).then((address) => {
        if (address.length > 0) searchInput.current.value = address[0]?.postcode
      })

      // find dealers
      getDealersList({ lat, lon }, (result) => {
        // const radiusResult = result.dealers.filter(dealer =>  dealer.distance < 50)
        setIsSearching(false)
        setDealers(result.dealers)
        addMarkers(result.dealers)
        setDealerFound(result.dealers.length > 0)
      })
    })
  }

  const searchByPostcode = (term) => {
    setDealers([])
    window.customMap.geocoder
      .search(term, { countryCode: ['GB', 'IM', 'JE', 'GG'] })
      .then((geo) => {
        if (geo.length) {
          const lon = geo[0].coordinates[0]
          const lat = geo[0].coordinates[1]

          getDealersList({ lat, lon }, (result) => {
            // const radiusResult = result.dealers.filter(dealer =>  dealer.distance < 50)
            setIsSearching(false)
            setDealers(result.dealers)
            addMarkers(result.dealers)
            setDealerFound(result.dealers.length > 0)
          })
        } else setDealerFound(false)
      })
  }

  const getDealersList = function (coords, callback) {
    setIsSearching(true)
    fetch(
      `https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/${brand}/gb/en/drive/${coords.lon}/${coords.lat}?count=10&extraCountries=&isCurrentLocation=false&services=ShowRoom`,
    )
      .then((response) => response.json())
      .then(callback)
      .catch((error) => {
        console.error('Error:', error)
        setIsSearching(false)
      })
  }

  const getOpeningDays = (opening) => {
    const services = [...new Set(opening.map((service) => service.service))]

    const days = services.map((service) => {
      let times = opening.map((el, index) => {
        if (el.service === service)
          return (
            <div className=" flex justify-between  leading-[22px] " key={index}>
              {el?.hours[0]?.startTime && (
                <div>
                  {el?.startDay}
                  {el?.endDay !== el?.startDay ? ' - ' + el?.endDay : ''}
                </div>
              )}
              {el?.hours[0]?.startTime && (
                <div>
                  {el?.hours[0]?.startTime} - {el?.hours[0]?.endTime}
                </div>
              )}
            </div>
          )
      })
      times = times.filter((el) => el)

      return (
        <div key={service}>
          <div className="  flex justify-between font-medium mt-4 leading-[30px] ">
            {service.toUpperCase()}
          </div>
          {times}
        </div>
      )
    })

    return days
  }

  const ratingStars = (rating) => {
    const stars = []
    for (var i = 0; i < Math.floor(rating); i++) {
      stars.push(
        <svg
          key={i}
          aria-hidden="true"
          className="w-5 h-5 text-black   "
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
        </svg>,
      )
    }
    return stars
  }

  const dealerList = (dealers) =>
    dealers.map((el, index) => (
      <div
        className={`dealer-${index} ${
          isMapView
            ? pinnedDealer !== index + 1
              ? ' hidden shadow-md lg:shadow-none lg:block'
              : 'block'
            : ''
        } ${
          isMapView ? ' bg-white ' : ' bg-grey '
        } text-base-text mb-[10px] py-[17px]  px-[20px] w-[100%] `}
        key={index}
      >
        <div className=" flex justify-between">
          <div className=" flex items-center ">
            <div className="w-[22px] title h-[22px] bg-base text-white text-sm rounded-full leading-[22px] flex justify-center items-center pb-[2px]">
              {index + 1}
            </div>
            <div className=" pl-2">
              {(el.distance * 0.62137119).toFixed(2)} miles
            </div>
          </div>
          <button
            className={`${isMapView ? ' block lg:hidden' : 'hidden'}`}
            onClick={() => {
              pinDealer(null)
              window.customMap.fitBoundsToMarkers({
                boundsPreservePaddingLeft:
                  document.documentElement.clientWidth < 900 ? 50 : 400,
                boundsPreservePaddingTop:
                  document.documentElement.clientWidth < 900 ? 250 : 50,
                boundsPreservePaddingBottom: 50,
                boundsPreservePaddingRight: 50,
              })
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="  flex mt-[10px] ">{el.name}</div>
        <div className={`${!isMapView ? 'flex' : ''} `}>
          <div className=" font-medium  leading-[27px] ">
            {el.address.address}
          </div>
          {el?.isDetailsExpanded && (
            <div className=" font-medium  leading-[27px] ">
              {el.address.address1}
              {`${!isMapView ? `,\xa0` : ''}`}
            </div>
          )}

          {el?.isDetailsExpanded && (
            <div className=" font-medium  leading-[27px]">
              {el.address.city}, {el.address.zip}
            </div>
          )}
        </div>
        {!el?.isDetailsExpanded && (
          <div className="  flex justify-between mt-4 ">
            <button
              className="   text-md underline  "
              onClick={(e) => {
                const editedDealer = dealers.map((dealer, i) => ({
                  ...dealer,
                  isDetailsExpanded: i === index ? true : el.isDetailsExpanded,
                }))
                window.customMap.focusOn({ coordinates: el.address.geo })
                setDealers(editedDealer)
              }}
              data-gt-name="componentevent"
              data-gt-componentgroup={tracking.componentGroup()}
              data-gt-componentname={tracking.componentName()}
              data-gt-action="map-toggle"
              data-gt-label="more details"
            >
              {brand === 'lexus' ? 'Full details' : 'More details'}
            </button>
            <CTA
              onClick={(e) => {
                selectDealer(el)
              }}
              data-gt-name="componentevent"
              data-gt-componentgroup={tracking.componentGroup()}
              data-gt-componentname={tracking.componentName()}
              data-gt-action="map-click-cta"
              data-gt-label="choose dealer"
            >
              {brand === 'lexus' ? 'Choose centre' : 'Choose Dealer'}
            </CTA>
          </div>
        )}
        {el?.isDetailsExpanded && (
          <>
            <button
              onClick={(e) => {
                const editedDealer = dealers.map((dealer, i) => ({
                  ...dealer,
                  isDetailsExpanded:
                    i === index ? false : dealer.isDetailsExpanded,
                }))
                setDealers(editedDealer)
              }}
              className="  flex justify-between items-center mt-[16px] w-[100%] text-md underline "
              data-gt-name="componentevent"
              data-gt-componentgroup={tracking.componentGroup()}
              data-gt-componentname={tracking.componentName()}
              data-gt-action="map-toggle"
              data-gt-label="less details"
            >
              <div>Less details</div>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.5 15.75l7.5-7.5 7.5 7.5"
                  />
                </svg>
              </div>
            </button>
            <div className="mt-3 ">
              <div className="  flex mt-[22px] ">
                Call:{' '}
                <a
                  className={` ${
                    brand === 'lexus' ? '' : 'font-medium '
                  }  ml-[2px]`}
                  href={`tel:${el.phone.trim()}`}
                  data-gt-name="componentevent"
                  data-gt-componentgroup={tracking.componentGroup()}
                  data-gt-componentname={tracking.componentName()}
                  data-gt-action="map-click-cta"
                  data-gt-label={`${el.phone.trim()}`}
                >
                  {' '}
                  {el.phone}
                </a>
              </div>

              {el.rating && (
                <div className="flex  mt-2 ">
                  <div className="relative flex ">
                    {ratingStars(el.rating.fivestar)}
                  </div>
                  <p className="ml-2 text-sm font-medium text-gray-500 dark:text-gray-400">
                    {el.rating.fivestar}
                  </p>
                </div>
              )}

              <button
                onClick={(e) => {
                  const editedDealer = dealers.map((dealer, i) => ({
                    ...dealer,
                    isOpeningExpanded:
                      i === index
                        ? !dealer?.isOpeningExpanded
                        : dealer?.isOpeningExpanded,
                  }))
                  setDealers(editedDealer)
                }}
                className={` ${
                  brand === 'lexus' ? '' : 'font-medium '
                }   flex justify-between items-center mt-3 w-[100%]`}
                data-gt-name="componentevent"
                data-gt-componentgroup={tracking.componentGroup()}
                data-gt-componentname={tracking.componentName()}
                data-gt-action="map-toggle"
                data-gt-label="opening hours"
              >
                <div>Services and Opening Hours</div>
                <div>
                  {el?.isOpeningExpanded && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 15.75l7.5-7.5 7.5 7.5"
                      />
                    </svg>
                  )}
                  {!el?.isOpeningExpanded && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                      />
                    </svg>
                  )}
                </div>
              </button>

              {el.isOpeningExpanded && getOpeningDays(el.openingDays)}
              <div className="mt-[20px] mb-[10px]">
                <CTA
                  className={`${
                    brand === 'lexus'
                      ? 'group flex items-center w-full justify-center !leading-10 pl-4 uppercase rounded bg-secondary text-white outline-0 hover:opacity-50 active:opacity-50 focus:opacity-50 disabled:cursor-not-allowed disabled:opacity-50'
                      : 'inline-flex items-center justify-center px-6 py-3 bg-base text-white outline-0 w-full hover:bg-base-hover active:bg-base-hover focus:bg-base-hover disabled:cursor-not-allowed disabled:bg-base-hover'
                  }`}
                  onClick={(e) => {
                    selectDealer(el)
                  }}
                  data-gt-name="componentevent"
                  data-gt-componentgroup={tracking.componentGroup()}
                  data-gt-componentname={tracking.componentName()}
                  data-gt-action="map-click-cta"
                  data-gt-label="choose dealer"
                >
                  {brand === 'lexus' ? 'Choose centre' : 'Choose Dealer'}
                </CTA>
              </div>
            </div>
          </>
        )}
      </div>
    ))

  return (
    <>
      {search && (
        <>
          <div
            className={` ${
              isMapView
                ? '  lg:max-w-[353px] lg:left-[20px] lg:top-[20px] top-20 '
                : ' top-[85px]  lg:max-w-[100%] '
            } absolute  mb-[10px]  left-[20px] right-[20px] z-[9]  max-h-[100%] `}
          >
            <div
              className={`group  ${
                isMapView ? ' bg-white ' : ' bg-grey '
              }  p-6 leading-[32px]  `}
            >
              {label}
              <div className="relative">
                <input
                  type="text"
                  id={`places`}
                  ref={searchInput}
                  className={`relative p-4 h-[48px] pl-[40px] mt-2 pr-[88px] w-[100%] text-ellipsis overflow-hidden`}
                  data-gt-name="componentevent"
                  data-gt-componentgroup={tracking.componentGroup()}
                  data-gt-componentname={tracking.componentName()}
                  data-gt-action="text-input-interaction"
                  data-gt-label="postcode location"
                />
                <div className="pointer-events-none absolute inset-y-0 bottom-[-5px] left-[2px] flex items-center pl-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5  "
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                    />
                  </svg>
                </div>
                <div
                  className={` z-9 absolute inset-y-0 ${
                    brand === 'lexus' ? ' ' : '   '
                  } bottom-[-9px] right-[60px] flex items-center pl-3`}
                >
                  <button
                    onClick={(e) => {
                      getDeviceGeoLocation()
                    }}
                    className={` ${
                      brand === 'lexus'
                        ? ' text-base-text '
                        : ' h-full text-sm '
                    } flex text-base-text h-full  `}
                    data-gt-name="componentevent"
                    data-gt-componentgroup={tracking.componentGroup()}
                    data-gt-componentname={tracking.componentName()}
                    data-gt-action="map-click-icon"
                    data-gt-label="geo location"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      className={`w-6 h-6 ${
                        brand === 'lexus' ? '' : '   '
                      } m-auto `}
                    >
                      <path
                        xmlns="http://www.w3.org/2000/svg"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 11l14-6-6 14-2-6-6-2z"
                      />
                    </svg>
                  </button>
                </div>
                <button
                  onClick={(e) => {
                    searchInput.current.value !== '' &&
                      searchByPostcode(searchInput.current.value)
                    searchInput.current.focus()
                  }}
                  className={`absolute right-1 bottom-1 h-10 ${
                    brand === 'lexus' ? '!uppercase' : ''
                  } px-4 py-1 p-4  text-sm text-gray capitalize flex items-center justify-center `}
                  data-gt-name="componentevent"
                  data-gt-componentgroup={tracking.componentGroup()}
                  data-gt-componentname={tracking.componentName()}
                  data-gt-action="map-click-cta"
                  data-gt-label="find"
                >
                  {isSearching && <div className="loader dark">Loading...</div>}
                  Find
                </button>
              </div>
              {!isDealerFound && (
                <div className="text-red text-tiny flex justify-between pt-2">
                  <span>No location found</span>
                  <Warning className="  h-4  mt-2" />
                </div>
              )}
            </div>
          </div>
          {dealers && (
            <div
              className={` ${
                isMapView
                  ? `  search-list lg:max-h-[calc(100vh-370px)] h-auto ${
                      pinnedDealer
                        ? ' z-[10]'
                        : 'shadow-md lg:shadow-none  z-1 lg:z-[10]'
                    } top-[80px] lg:top-[165px]  lg:max-w-[353px] lg:left-[20px]`
                  : ' top-[230px] lg:max-w-[100%]  lg:top-[230px]  '
              } absolute  left-[20px] right-[20px]     overflow-y-auto    `}
            >
              {dealerList(dealers)}
            </div>
          )}
        </>
      )}

      {
        <div className=" absolute right-[20px] top-[20px] flex">
          <div
            className={` bg-white text-[15px] leading-[50px] w-[131px] h-[50px] z-10 flex`}
          >
            <button
              className={`w-[100%] text-center ${
                isMapView ? ' underline ' : ''
              }`}
              onClick={(e) => {
                setMapView(true)
              }}
              data-gt-name="componentevent"
              data-gt-componentgroup={tracking.componentGroup()}
              data-gt-componentname={tracking.componentName()}
              data-gt-action="map-click-cta"
              data-gt-label="map view"
            >
              Map
            </button>
            <button
              className={`w-[100%] text-center ${
                isMapView ? '' : ' underline '
              }`}
              onClick={(e) => {
                setMapView(false)
              }}
              data-gt-name="componentevent"
              data-gt-componentgroup={tracking.componentGroup()}
              data-gt-componentname={tracking.componentName()}
              data-gt-action="map-click-cta"
              data-gt-label="list view"
            >
              List
            </button>
          </div>
        </div>
      }

      {
        <div
          // removed overflow-auto to fix map bug
          className={`absolute  w-full h-screen md:h-full left-0 toyota-map ${
            isMapView ? '' : ' hidden '
          } `}
          ref={mapsElement}
        ></div>
      }
    </>
  )
}

export default Map
